// extracted by mini-css-extract-plugin
export default {"socialShareBar":"UcVdt","listItem":"zK1ik","link":"gU_QY","icon":"Ahq5v"};